<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')" v-if="checkPermissionButton('新增')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.inventory_customer_name" placeholder="请输入客户名称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.inventory_customer_person" placeholder="请输入负责人名称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCustomerName" label="客户名称"></el-table-column>
            <el-table-column prop="inventoryCustomerPerson" label="客户负责人"></el-table-column>
            <el-table-column prop="inventoryCustomerMemo" label="客户备注"></el-table-column>
            <el-table-column prop="inventoryCustomerLegalName" label="法人"></el-table-column>
            <el-table-column prop="inventoryCustomerLegalPhone" label="法人电话"></el-table-column>
            <!-- <el-table-column prop="inventoryCustomerFinanceName" label="财务负责人" width="260">
                <template slot-scope="scope">
                    <div>
                        <div>姓名：{{ scope.row.inventoryCustomerFinanceName }}，电话：{{ scope.row.inventoryCustomerFinancePhone }}</div>
                        <div>身份证号：{{ scope.row.inventoryCustomerFinanceCard }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="inventoryCustomerFinanceName" label="办税负责人" width="260">
                <template slot-scope="scope">
                    <div>
                        <div>姓名：{{ scope.row.inventoryCustomerRoyaltyName }}，电话：{{ scope.row.inventoryCustomerRoyaltyPhone }}</div>
                        <div>身份证号：{{ scope.row.inventoryCustomerRoyaltyCard }}</div>
                    </div>
                </template>
            </el-table-column> -->

            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="showDetail(scope.row)" type="text" size="small" v-if="checkPermissionButton('查看')">查看</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small" v-if="checkPermissionButton('编辑')">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small" v-if="checkPermissionButton('删除')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="50%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="160px">
                    <el-form-item label="客户名称">
                        <el-input v-model="handleInfo.inventoryCustomerName"></el-input>
                    </el-form-item>
                    <el-form-item label="客户负责人">
                        <el-input v-model="handleInfo.inventoryCustomerPerson"></el-input>
                    </el-form-item>
                    <el-form-item label="客户备注">
                        <el-input v-model="handleInfo.inventoryCustomerMemo"></el-input>
                    </el-form-item>

                    <el-form-item label="法人">
                        <el-input v-model="handleInfo.inventoryCustomerLegalName"></el-input>
                    </el-form-item>
                    <el-form-item label="法人电话">
                        <el-input v-model="handleInfo.inventoryCustomerLegalPhone"></el-input>
                    </el-form-item>

                    <el-form-item label="财务负责人">
                        <el-input v-model="handleInfo.inventoryCustomerFinanceName"></el-input>
                    </el-form-item>
                    <el-form-item label="财务负责人身份证号">
                        <el-input v-model="handleInfo.inventoryCustomerFinanceCard"></el-input>
                    </el-form-item>
                    <el-form-item label="财务负责人电话">
                        <el-input v-model="handleInfo.inventoryCustomerFinancePhone"></el-input>
                    </el-form-item>

                    <el-form-item label="办税人">
                        <el-input v-model="handleInfo.inventoryCustomerRoyaltyName"></el-input>
                    </el-form-item>
                    <el-form-item label="办税人身份证号">
                        <el-input v-model="handleInfo.inventoryCustomerRoyaltyCard"></el-input>
                    </el-form-item>
                    <el-form-item label="办税人电话">
                        <el-input v-model="handleInfo.inventoryCustomerRoyaltyPhone"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <div v-if="isDetail" style="position: fixed; top: 0px; left: 0px; z-index: 9; width: 100%; height: 100vh; background: #FFFFFF;">
            <PaymentDetailComponent :customer-id="customerId" @close="isDetail = false"></PaymentDetailComponent>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import PaymentDetailComponent from "@/components/PaymentDetailComponent.vue"

export default {
    components: {
        PaymentDetailComponent,
    },
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            customerId: "",
            isDetail: false,
        }
    },
    methods: {
        showDetail: function(row) {
            this.customerId = row.inventoryCustomerId;
            this.isDetail = true;
        },
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>